import React, { FC, ReactNode, SyntheticEvent } from 'react'
import { useAddPopupMessage, useDownloadingFile } from 'src/hooks/ui'
import { StyledLink } from './styledLink'

interface PresignedDownloadLinkProps {
  /** Fetches the presigned URL; the api instance's transformer unwraps the envelope, so `data` is the URL string. */
  getUrl: () => Promise<{ data: unknown; status: number }>;
  children: ReactNode;
}

export const PresignedDownloadLink: FC<PresignedDownloadLinkProps> = ({ getUrl, children }) => {
  const { downloadUrl } = useDownloadingFile()
  const addMessage = useAddPopupMessage()

  const onClick = async (event: SyntheticEvent) => {
    event.preventDefault()
    event.stopPropagation()
    try {
      const { data, status } = await getUrl()

      if (status === 200 && typeof data === 'string' && data) {
        await downloadUrl(data)
      } else {
        addMessage({ text: 'Download link is not available', type: 'error' })
      }
    } catch (error) {
      // the api instance throws on the response envelope error (e.g. 404 when the file is missing)
      addMessage({ text: (error as Error).message, type: 'error' })
    }
  }

  return (
    <StyledLink href={'/'} onClick={onClick}>
      {children}
    </StyledLink>
  )
}
